import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap, Icon } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]).isRequired,
    color: PropTypes.oneOf(['primary', 'secondary']),
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'button',
    color: 'primary',
    disabled: false,
};

class AddButton extends Abstrap {

    getClassNameSchema() {
        const {
            color,
            className,
            disabled,
        } = this.props;
        return [
            'c-add-btn',
            disabled ? 'c-add-btn_is-disabled' : false,
            `c-add-btn--${color}`,
            className,
        ];
    }

    renderChildren() {
        const {
            children,
        } = this.props;
        return (
            <>
                <span className="c-add-btn__icon">
                    <Icon icon="plus" />
                </span>
                <span className="c-add-btn__text">
                    {children}
                </span>
            </>
        );
    }

}

AddButton.propTypes = propTypes;

AddButton.defaultProps = defaultProps;

export default AddButton;
